var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"azulMuyClaro"},[_c('landing'),_c('nosotros'),_c('marcas'),_c('sectores'),_c('servicios'),_c('contacto')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }